import { render, staticRenderFns } from "./MediaLinks.vue?vue&type=template&id=13faa8cc&"
import script from "./MediaLinks.vue?vue&type=script&lang=js&"
export * from "./MediaLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports